/**
 * Transforms Marketplace Workflow API response into FlowBuilder initial state object.
 * Maps backend step and option structure into canvas nodes and steps.
 */
export function transformMarketplaceWorkflowToFlowState(marketplaceWorkflow) {
  if (!marketplaceWorkflow) return null;

  const {
    name,
    trigger_type,
    welcome_message,
    completion_message,
    keywords,
    steps = [],
  } = marketplaceWorkflow;

  // Map step nodes with full property support
  const builderSteps = (steps || []).map((step, index) => ({
    id: step.id || index + 1,
    order: step.step_order ?? step.order ?? index + 1,
    question_text: step.question_text || '',
    media_type: step.media_type || 'text',
    media_url: step.media_url || '',
    is_open_ended: Boolean(step.is_open_ended),
    is_confirmation_step: Boolean(step.is_confirmation_step),
    is_datetime_step: Boolean(step.is_datetime_step),
    is_quotation_step: Boolean(step.is_quotation_step),
    is_windex_step: Boolean(
      step.is_windex_step ||
      String(step.type || step.step_type || '').toLowerCase() === 'windex',
    ),
    windex_year: step.windex_year || '',
    windex_field: step.windex_field || '',
    windex_reply_template: step.windex_reply_template || '',
    windex_no_result_message: step.windex_no_result_message || '',
    windex_no_result_next_step_order:
      step.windex_no_result_next_step_order ?? null,
    is_google_sheet_step: Boolean(
      step.is_google_sheet_step ||
      ['google_sheet', 'sheet_lookup', 'spreadsheet'].includes(
        String(step.type || step.step_type || '').toLowerCase(),
      ),
    ),
    google_sheet_spreadsheet_id: step.google_sheet_spreadsheet_id || '',
    google_sheet_name: step.google_sheet_name || '',
    google_sheet_lookup_column: step.google_sheet_lookup_column || '',
    google_sheet_lookup_source: step.google_sheet_lookup_source || 'message',
    google_sheet_lookup_variable: step.google_sheet_lookup_variable || '',
    google_sheet_reply_template: step.google_sheet_reply_template || '',
    google_sheet_no_match_message: step.google_sheet_no_match_message || '',
    google_sheet_found_next_step_order:
      step.google_sheet_found_next_step_order ?? null,
    google_sheet_not_found_next_step_order:
      step.google_sheet_not_found_next_step_order ?? null,
    working_hours_start: step.working_hours_start || null,
    working_hours_end: step.working_hours_end || null,
    break_time_start: step.break_time_start || null,
    break_time_end: step.break_time_end || null,
    slot_duration_minutes: step.slot_duration_minutes || null,
    available_days_count: step.available_days_count || 7,
    timezone: step.timezone || 'Asia/Kolkata',
    variable_name: step.variable_name || '',
    next_step_id: step.next_step_id || null,
    next_step_order: step.next_step_order || null,
    stage_id: step.stage_id ?? step.stage?.id ?? null,
    stage: step.stage || null,
    options: (step.options || []).map((opt, optIdx) => ({
      id: opt.id || optIdx + 1,
      number: opt.option_number ?? opt.number ?? optIdx + 1,
      text: opt.option_text ?? opt.text ?? '',
      next_step_id: opt.next_step_id || null,
      next_step_order: opt.next_step_order || null,
      stage_id: opt.stage_id ?? opt.stage?.id ?? null,
      stage: opt.stage || null,
    })),
  }));

  return {
    id: null, // Signals new flow creation
    name: name || 'Automation',
    trigger_type: trigger_type || 'WELCOME',
    welcome_message: welcome_message || '',
    completion_message: completion_message || '',
    keywords: keywords || '',
    is_active: false,
    is_draft: true,
    steps: builderSteps,
  };
}
